import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["values"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 11:28:39
 * @LastEditTime: 2021-06-30 17:44:40
 * @LastEditors: wangshengqiang
 * @Description: fdsa
 */
import classnames from 'classnames';
import React, { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import { isPreviewMode } from '@/utils/tool';
import QuestionItem from '../Question/questionItem';
import StickyScroll from './StickyScroll';
const QuestionMore = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs,
    children
  } = props;

  const {
    values = []
  } = attrs,
        others = _objectWithoutProperties(attrs, _excluded);

  const cls = classnames({
    'components-question-more-render': true
  }); // 获取锚点的项目

  const topList = values.filter(item => item.anchor).map(item => ({
    key: item.id,
    value: item.anchor
  }));
  const contentList = values.map((item = {}, index) => {
    const {
      label = '',
      value = '',
      id
    } = item;
    return {
      element: /*#__PURE__*/React.createElement(QuestionItem, {
        className: "more-item",
        key: index,
        label: label
      }, value),
      id
    };
  }); // 微信浏览器的 bug 页面会自动滚动到最下面 2020-11-26 huaqingfeng

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), /*#__PURE__*/React.createElement(StickyScroll, {
    className: "more-tabs",
    isFlex: false,
    contentList: contentList,
    list: topList
  }, // 不知道干什么用的, 预览模式先不显示
  !isPreviewMode() ? /*#__PURE__*/React.createElement("div", {
    style: {
      height: 'calc(100vh - 140px)'
    }
  }) : null), /*#__PURE__*/React.createElement(GlobalStyled, null));
});
export default QuestionMore;
const GlobalStyled = createGlobalStyle`
  #container {
    height: auto !important;
  }
`;